import { Component, OnInit } from '@angular/core';
import{IssueStage} from 'src/app/services/bug-module/StageType-enum';
import {BugModuleService} from 'src/app/services/bug-module/bug-module.service';
import {UserService} from 'src/app/services/user/user.service';
import { ToastrService } from 'ngx-toastr';
import { BugReportDTO } from 'src/app/dtos/BugReportDTO';
import { UserDetailsService } from 'src/app/services/user-details.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import {ImageDialogComponent} from 'src/app/components/bug-module/image-dialog/image-dialog.component';
import { ViewChild, TemplateRef } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {ViewBugComponent}from "../view-bug/view-bug.component"



@Component({
  selector: 'app-status-bug',
  templateUrl: './status-bug.component.html',
  styleUrls: ['./status-bug.component.scss']
})
export class StatusBugComponent implements OnInit {
  position = {
    value: 'above'
  };
  isSpinnerActive: boolean = true;
  isAll;
  page:number=1;
  pageSize:number=20
  totalPages:number=0;
  yearSearch;
  years:number[]=[];
  isOpen;
  isClose;
  issues: BugReportDTO[] = [];
  updatedIssue: BugReportDTO = {} as BugReportDTO;
  filteredIssues
  stages:string[]=[];
  stage;
  stageSearch;
  status: string="All";
  statusSearch;
  searchQuery;
  userdto;
  updateStageSearch;
  stageUpdate;
  hasResourceAccessRights:boolean=false;
  hasDeveloperRights:boolean=false;
  hasManagerRights:boolean=false;
  treeloLink;
  AdditionalInfo;
  hasHrRights:boolean=false;

   @ViewChild('viewModal', { static: true }) viewModalRef: TemplateRef<any>;
  selectedIssue: any;

  constructor(private modalService: NgbModal,public bugmoduleservice: BugModuleService,public userservice: UserService,private toast: ToastrService,public userDetailService: UserDetailsService,private dialog: MatDialog) { }

  ngOnInit(): void {
    this.All();
    this.setStages();
    this.setYears();
    this.hasResourceAccessRights = this.userDetailService.hasRole([
      'ROLE_SUPER_ADMIN',
      'ROLE_HUMAN_RESOURCE',
      'ROLE_PULSE_MANAGER',
      'ROLE_PULSE_DEVELOPER'
    ]);
    this.hasHrRights=this.userDetailService.hasRole([
      'ROLE_SUPER_ADMIN',
      'ROLE_HUMAN_RESOURCE'
    ]);
    this.hasDeveloperRights=this.userDetailService.hasRole([
      'ROLE_PULSE_MANAGER',
      'ROLE_PULSE_DEVELOPER'
    ]);
    this.hasManagerRights=this.userDetailService.hasRole([
      'ROLE_PULSE_MANAGER'
    ]);
    this.getAllIssuesList();
  }
  stageFlows = {
    Bug: ["Reported", "Resolving", "Resolved",'Decline'],
    Enhancement: ["Reported", "Developing", "Developed",'Decline'],
    Question: ["Received_Question", "Answered_Question"],
    Feedback: ["Received_Feedback"]
  };
  openViewModal(issue: any): void {
    this.selectedIssue = issue;
    this.modalService.open(this.viewModalRef, { size: 'lg' });
  }

  
  getStages(issue: any): string[] {
    return this.stageFlows[issue.selectedIssue] || [];
  }
  onClick(issue: string) {
  const dialogConfig = new MatDialogConfig();
  dialogConfig.disableClose = true;
  dialogConfig.autoFocus = true;
  dialogConfig.width = '85%';
  dialogConfig.height = '90%';

  // ❗ FIXED: Send entire issue object, not just issue.id
  dialogConfig.data = issue;

  dialogConfig.panelClass = 'activate-employee';

  const dialogRef = this.dialog.open(ViewBugComponent, dialogConfig);
  dialogRef.afterClosed().subscribe(() => {this.getAllIssuesList();});
  
}

  onPageChange(event){
    this.page = event;
    this.onFiltreChange();
  }
  setStages(){
    this.stages = Object.values(IssueStage); 
  }
  setYears() {
    const currentYear = new Date().getFullYear();
    this.years = [];
    for (let year = 2024; year <= currentYear; year++) {
      this.years.push(year);
    }
  }
  getStageTitleKeyByValue(value: string): string | undefined {
    return Object.keys(IssueStage).find(key => IssueStage[key] === value);
  }
  getAllIssuesList() {
    this.isSpinnerActive = true;
    this.issues = [];
    this.filteredIssues = [];

    this.bugmoduleservice.getIssues(
      this.searchQuery,
      this.statusSearch,
      this.stageSearch,
      this.yearSearch,
      this.page - 1,
      this.pageSize,
    ).subscribe(res => {
      this.issues=res.body.content;
      this.totalPages = res.body?.totalPages || 0;
      this.updateStageSearch="";
      this.isSpinnerActive = false;
    }, () => {
      this.isSpinnerActive = false;
    });
    
  }
    
  All(){
    this.status = "All";
    this.onFiltreChange();
    this.isAll=true;
    this.isOpen=false;
    this.isClose=false;
  }
  Close(){
    this.status = "Close";
    this.onFiltreChange();
    this.isAll=false;
    this.isOpen=false;
    this.isClose=true;
  }
  Open(){
    this.status = "Open";
    this.onFiltreChange();
    this.isAll=false;
    this.isOpen=true;
    this.isClose=false;
  }
  onFiltreChange(){
    this.page = 1; 
    this.statusSearch = this.status;
    this.getAllIssuesList();
  }
  ifOverflow(e) {
    return e.scrollWidth > e.clientWidth;
  }
 
  onSearchInput(value: string): void {
    this.searchQuery = value.trim();
    this.onFiltreChange();
  }
  updateStage(issue: BugReportDTO) { 
    this.updatedIssue = {
      bugId: issue.bugId,
      stage: this.updateStageSearch
    } as BugReportDTO;
  
    this.bugmoduleservice.updateStage(this.updatedIssue).subscribe({
      next: (res) => {
        this.toast.success('Stage Updated!', 'Success');
        this.getAllIssuesList();
      },
      error: (err) => {
        console.error('Error occurred while updating the stage!', err);
        this.toast.error('Error occurred while updating the stage!', 'Error');
      }
    });
  }
  notify(issue){
    this.bugmoduleservice.notifyAll(issue).subscribe({
      next: (res) => {
        this.toast.success('Notification Sent!', 'Success');
      },
      error: (err) => {
        console.error('Error occurred while sending the notification!', err);
        this.toast.error('Error occurred while sending the notification!', 'Error');
      }
    });
  }
  updateInfo(issue: BugReportDTO) {
    const updatedInfo = Object.assign(new BugReportDTO(), {
      bugId: issue.bugId,
      treeloLink: this.treeloLink,
      AdditionalInfo: this.AdditionalInfo,
      pntComments:this.AdditionalInfo,
      ...issue
    });
    this.bugmoduleservice.updateAdditionalInfo(updatedInfo).subscribe({
      next: (res) => {
        this.toast.success('Info updated successfully!', 'Success');
        this.getAllIssuesList();
      },
      error: (err) => {
        console.error('Error while updating info:', err);
        this.toast.error('Failed to update info!', 'Error');
      }
    });
  } 
  openImage(issue){
    const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.width = "85%";
        dialogConfig.height = "90%";
        dialogConfig.data=issue;
        dialogConfig.panelClass = "activate-employee"
        const dialogRef = this.dialog.open(ImageDialogComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(() => { });
  }

  getUserImage(userImage: string): string {
  if (!userImage || userImage.trim() === '') {
    return 'assets/icons/default-avatar.jpg';
  }

  // Add base64 prefix if missing
  if (!userImage.startsWith('data:image')) {
    return 'data:image/png;base64,' + userImage;
  }

  return userImage;
}
  
}
